import { LocalRxdbProperties } from './local-rxdb-properties.model';

/* eslint-disable @typescript-eslint/naming-convention */
export interface DataModel extends LocalRxdbProperties {
	table_id?: string;
	table_name?: string; //"DRILL_HOLE_DIRECTION",
	hole_number?: string; //"CA-MTL-20-001",
	depth?: number; //"0.0000",
	test_type_Code?: string; //"COLL",
	corrected_azi_factor?: number; //"16.90",
	date_surveyed?: string; //"2018-02-18T00:00:00",
	uncorrected_azimuth?: number; //"134.00",
	mag_reading?: number; //"54826.0000",
	flag?: string; //"O"
	hole_type_code?: string; //"DD",
	hole_size_id?: string; //"HQ",
	hole_location?: string; //"",
	core_storage?: string; //:"",
	casing?: string; //:"",
	uofd_code?: string; //:"DECIMAL",
	uofm_code?: string; //:"METRIC",
	azimuth_decimal?: number; //:150.90,
	dip_decimal?: number; //:-57.20,
	collar_survey_taken?: string; //:"N",
	pulse_em_survey_taken?: string; //:"N",
	multi_shot_survey?: string; //:"N",
	is_making_water?: string; //:"N",
	is_hole_plugged?: string; //:"N",
	is_cemented?: string; //:"N",
	gas_intersected?: string; //:"N",
	object_in_hole?: string; //:"N",
	verified?: string; //:"N",
	start_date?: string; //:"2020-02-18T00:00:00",
	completed_date?: string; //:"2020-02-22T00:00:00",
	entered_by?: string; //:"",
	entered_on?: string; //:"2018-02-18T00:00:00",
	final_depth?: number; //:429.00,
	maximum_depth?: number; //:440.00,
	validated?: string; //:0,
	responsible_person?: string; //:"Al R.",
	hole_purpose?: string; //:"Intersect vein plane 76-133m with 2x phase two targets",
	program_type?: string; //:"DEL",
	data_source?: string; //:"DHLogger",
	eoh_reason?: string; //:"Target Reached\/Exceeded",
	casing_depth?: number; //:6.00,
	drill_contractor?: string; //:"Boart",
	company?: string; //:"DM",
	hole_status?: string; //:"COMPLETE",
	planned_dh_depth?: number; //:429.00
	depth_from?: number | string;
	depth_to?: number | string;
	assay_sample_type_code?: string;
	is_minor?: string;
	inserted_depth?: string;
	project_number?: string;
	sample_number?: string;
	external_created_record?: string;
	external_modified_record?: string;
	parent_sample_number?: string;
	is_master?: string;
}
